<template>
  <v-container fluid class="fill-height py-0">
    <v-row justify="center" align="center" class="skewed-bg">
      <v-col cols="12" sm="11" md="10" style="z-index:1" class="pa-0">
        <v-row>
          <v-col cols="12" align="right" class="pa-0">
            <v-btn
              :class="mobile ? ' my-2' : 'mr-4'"
              tile
              color="#0e62ed"
              dark
              :block="mobile"
              :to="{ name: 'Create Word', params: { mode: 'create' } }"
              v-if="permission_create_edit_word"
            >
              <v-icon left>mdi-plus-circle</v-icon>
              <h4 class="mt-1">{{ btn_transcription_title }}</h4>
            </v-btn>
            <!-- <v-btn
              :class="mobile ? 'my-2' : 'ma-2'"
              tile
              color="#0e62ed"
              outlined
              :block="mobile"
            >
              <v-icon left>mdi-note-text</v-icon>
              <h4 class="mt-1">{{ btn_history_title }}</h4>
              <v-icon right>mdi-chevron-down </v-icon>
            </v-btn>-->
            <v-menu :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  :class="mobile ? 'my-2' : 'my-2'"
                  tile
                  color="#0e62ed"
                  outlined
                  :block="mobile"
                  v-on="on"
                  v-if="
                    permission_satisfaction ||
                      permission_history ||
                      permission_unknown_word
                  "
                >
                  <v-icon left>mdi-note-text</v-icon>
                  <h4 class="mt-1">{{ btn_history_title }}</h4>
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item
                    @click
                    :to="
                      permission_history
                        ? { name: 'History', params: { mode: 'history' } }
                        : permission_unknown_word
                        ? { name: 'History', params: { mode: 'unknown_word' } }
                        : ''
                    "
                    v-if="permission_history || permission_unknown_word"
                  >
                    <v-list-item-action class="mr-2">
                      <v-icon>mdi-note-text</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>ประวัติการค้นหาคำทับศัพท์</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click :to="'/satisfaction'" v-if="permission_satisfaction">
                    <v-list-item-action class="mr-2">
                      <v-icon>mdi-note-text</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>แบบประเมินความพึงพอใจ</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="my-10 pa-0">
            <v-card>
              <v-card-title>
                <h1>การแจ้งเตือนของคุณ</h1>
              </v-card-title>
              <v-container>
                <v-row class="px-2">
                  <v-col cols="12" sm="6" md="5" class="py-0">
                    <v-row>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-menu
                          ref="menu_start_date"
                          v-model="menu_start_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="start_dateFormatted"
                              placeholder="วันที่เริ่มต้น"
                              single-line
                              dense
                              solo
                              append-icon="event"
                              v-on="on"
                              clearable
                              @click:clear="start_date = ''"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="start_date"
                            no-title
                            @input="menu_start_date = false"
                            locale="th"
                            :max="end_date"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-menu
                          ref="menu_end_date"
                          v-model="menu_end_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="end_dateFormatted"
                              placeholder="วันที่สิ้นสุด"
                              single-line
                              dense
                              solo
                              append-icon="event"
                              v-on="on"
                              clearable
                              @click:clear="end_date = ''"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="end_date"
                            no-title
                            locale="th"
                            @input="menu_end_date = false"
                            :min="start_date"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" md="7" class="py-0">
                    <v-row>
                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-text-field
                          v-model="search"
                          solo
                          dense
                          single-line
                          placeholder="ค้นหา"
                          append-icon="mdi-magnify"
                          clearable
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" align="right" class="py-0 px-0">
                    <v-col cols="12" md="3" sm="6" class="py-0">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-row>
                            <v-col cols="12" sm="12" md="12" class="py-0">
                              <v-autocomplete
                                v-model="filter_language"
                                :items="language_list"
                                item-text="languageName"
                                item-value="languageId"
                                outlined
                                single-line
                                dense
                                placeholder="ภาษาทั้งหมด"
                                clearable
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>

                <v-row class="px-2">
                  <v-col cols="12" class="pt-0">
                    <v-card flat>
                      <p class="text_title_3">การแจ้งเตือนทั้งหมด {{ count_request }} รายการ</p>
                    </v-card>

                    <v-data-table
                      id="table-text"
                      :headers="headers"
                      :items="table_detail"
                      class="elevation-1"
                      :loading="loading"
                      hide-default-footer
                      :items-per-page="item_per_page"
                    >
                      <template v-slot:item.requestWordStatus="{ item }">
                        <v-chip color="#ABEBC6" v-if="item.requestWordStatus == 'active'">
                          <span class="text_body_7">{{ "ดำเนินการสำเร็จ" }}</span>
                        </v-chip>
                        <v-chip color="#F5CBA7" v-else>
                          <span class="text_body_7">{{ "รอดำเนินการ" }}</span>
                        </v-chip>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn text @click="replyEmail(item)">
                          <v-icon left>reply</v-icon>
                          <span class="text_body_7">ตอบกลับ</span>
                        </v-btn>
                        <v-btn
                          text
                          @click="addWord(item)"
                          :disabled="
                            item.requestWordStatus == 'active' ||
                              !permission_create_edit_word
                          "
                        >
                          <v-icon left>add</v-icon>
                          <span class="text_body_7">เพิ่มคำทับศัพท์</span>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <div class="text-center">
                      <v-pagination :total-visible="20" v-model="page" :length="total_page"></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      // perission variable
      permission_create_edit_word: false,
      permission_history: false,
      permission_satisfaction: false,
      permission_unknown_word: false,
      btn_transcription_title: "สร้างคำทับศัพท์",
      btn_history_title: "ประวัติการเข้าใช้งาน",

      headers: [
        {
          text: "วันที่",
          width: "15%",

          sortable: false,
          value: "createdAt",
        },
        {
          text: "อีเมล",
          value: "emailRequest",
          sortable: false,
          width: "20%",
        },
        {
          text: "คำศัพท์",
          value: "requestWordName",
          sortable: false,
          width: "20%",
        },
        {
          text: "ภาษา",
          value: "languageName",
          sortable: false,
          width: "20%",
        },
        {
          text: "ข้อมูลเพิ่มเติม",
          value: "comment",
          sortable: false,
          width: "20%",
        },
        {
          text: "สถานะ",
          value: "requestWordStatus",
          sortable: false,
          width: "20%",
          align: "center",
        },
        {
          text: "จัดการ",
          value: "actions",
          sortable: false,
          width: "20%",
          align: "left",
        },
      ],
      table_detail: [],
      menu: false,
      start_date: "",
      end_date: "",
      start_dateFormatted: "",
      end_dateFormatted: "",
      menu_start_date: false,
      menu_end_date: false,

      language_list: [],
      item_per_page: 20,
      filter_language: 0,

      search: "",
      search_setTimeout: null,
      search_const_delay: 500,

      page: 1,
      total_page: 0,
      count_request: 0,
      params: "",
      loading: false,
    };
  },
  created() {
    const module_name = "permission_backOffice";
    const func_name = "request_word_and_notification";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        // initial
        this.initialMethod();
        // set detail
        this.permission_create_edit_word = this.$session
          .get(module_name)
          .includes("create_edit_word");
        this.permission_satisfaction = this.$session
          .get(module_name)
          .includes("satisfaction");
        this.permission_history = this.$session
          .get(module_name)
          .includes("history");
        this.permission_unknown_word = this.$session
          .get(module_name)
          .includes("unknown_word");
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  watch: {
    "$route.query.search"(value) {
      if (value) {
        this.search = value;
      } else {
        this.search = "";
      }
    },
    start_date(val) {
      this.start_dateFormatted = this.thaiShortFormatDate(this.start_date);
      this.page = 1;
      this.searchNumberPage();
    },
    end_date(val) {
      this.end_dateFormatted = this.thaiShortFormatDate(this.end_date);
      this.page = 1;
      this.searchNumberPage();
    },

    filter_language(val) {
      this.page = 1;
      this.searchNumberPage();
    },

    search(val) {
      this.page = 1;
      clearTimeout(this.search_setTimeout);
      this.search_setTimeout = setTimeout(() => {
        this.searchNumberPage();
      }, this.search_const_delay);
    },
    page(val) {
      this.searchNumberPage();
    },
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    initialMethod() {
      if (this.$route.query.search) {
        this.search = this.$route.query.search;
      } else {
        this.search = "";
      }
      this.searchNumberPage();
      this.getLanguage();
    },
    changeMode(mode) {
      this.filter_mode = mode;
      this.page = 1;
      this.searchNumberPage();
    },
    replyEmail(item) {
      // console.log(item);
      this.$router.push({
        path: "/reply",
        query: { id: item.requestWordId, email: item.emailRequest },
      });
    },
    addWord(item) {
      // console.log(item);
      this.$store.state.moduleCreateEditWord.pointerId = item.pointerId;
      this.$store.state.moduleCreateEditWord.requestWordId = item.requestWordId;
      this.$store.state.moduleCreateEditWord.selected_language = [];
      this.$store.state.moduleCreateEditWord.selected_id = [];
      this.$store.state.moduleCreateEditWord.createMode = "request";
      this.$store.state.moduleCreateEditWord.selected_language.push(
        item.languageId
      );
      this.$store.state.moduleCreateEditWord.created_word = {
        categoryId: 0,
        mean: "",
        subLanguage: [],
      };
      this.$store.state.moduleCreateEditWord.created_word.subLanguage.push({
        languageId: item.languageId,
        alphabet: item.requestWordName,
        rule: "",
        transcriptionList: [{ transcriptionName: "" }],
      });

      this.$router.push({ name: "Create Word", params: { mode: "create" } });
    },
    searchNumberPage() {
      this.loading = true;
      this.params = "";
      var search = this.search
        ? "?search=" + encodeURIComponent(this.search.trim())
        : "?search=";
      var filter_start_date = this.start_date
        ? "&start=" + this.start_date
        : "&start=";
      var filter_end_date = this.end_date ? "&end=" + this.end_date : "&end=";
      var filter_language = this.filter_language
        ? "&languageId=" + this.filter_language
        : "&languageId=";
      var params =
        search +
        filter_start_date +
        filter_end_date +
        filter_language +
        "&mode=list";
      this.params = params;
      this.axios
        .get(
          process.env.VUE_APP_API +
            "/api/v1/requestword/numberpage/" +
            this.item_per_page +
            this.params,
          this.header_token
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data) {
            var data = res.data;
            this.total_page = data.page;
            this.count_request = this.formatNumber(data.count);
            this.searchList();
          }
        });
    },
    searchList() {
      this.axios
        .get(
          process.env.VUE_APP_API +
            "api/v1/requestword/page/" +
            this.item_per_page +
            "/" +
            this.page +
            this.params,
          this.header_token
        )
        .then((res) => {
          var data = res.data;
          var detail = [];
          data.forEach((element) => {
            var date = element.createdAt.split(" ")[0];
            var formatDate = this.thaiShortFormatDate(date);
            element.createdAt = formatDate;
            detail.push({
              alphabet: element.alphabet ? element.alphabet : "-",
              comment: element.comment ? element.comment : "-",
              createdAt: element.createdAt,
              createdBy: element.createdBy ? element.createdBy : "-",
              emailRequest: element.emailRequest ? element.emailRequest : "-",
              fullnameRequest: element.fullnameRequest
                ? element.fullnameRequest
                : "-",
              languageId: element.languageId ? element.languageId : null,
              languageName: element.languageName ? element.languageName : "-",
              pointerId: element.pointerId ? element.pointerId : null,
              requestWordId: element.requestWordId
                ? element.requestWordId
                : null,
              requestWordName: element.requestWordName
                ? element.requestWordName
                : "-",
              requestWordStatus: element.requestWordStatus
                ? element.requestWordStatus
                : "-",
            });
          });

          this.table_detail = detail;
          this.loading = false;
        });
    },

    getLanguage() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/language",
          this.header_token
        )
        .then((res) => {
          this.language_list = res.data;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    thaiShortFormatDate(date_str) {
      if (!date_str) {
        return "";
      }
      var [year, month, day] = date_str.split("-");
      year = parseInt(year) + 543 - 2500;
      switch (month) {
        case "01":
          month = "ม.ค.";
          break;
        case "02":
          month = "ก.พ.";
          break;
        case "03":
          month = "มี.ค.";
          break;
        case "04":
          month = "เม.ย.";
          break;
        case "05":
          month = "พ.ค.";
          break;
        case "06":
          month = "มิ.ย.";
          break;
        case "07":
          month = "ก.ค.";
          break;
        case "08":
          month = "ส.ค.";
          break;
        case "09":
          month = "ก.ย.";
          break;
        case "10":
          month = "ต.ค.";
          break;
        case "11":
          month = "พ.ย.";
          break;
        case "12":
          month = "ธ.ค.";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>
<style>
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
</style>
